import * as fromDatatype from '../../datatype-library/index';
import { BaseContainerModel } from '../base-container.model';

export class MrpPackingOrderCustomContainerSizeContainer extends BaseContainerModel {
  delivery_order_hdr_guid: fromDatatype.GuidDataFieldInterface;
  delivery_order_line_guid: fromDatatype.GuidDataFieldInterface;
  packing_order_hdr_guid: fromDatatype.GuidDataFieldInterface;
  packing_order_line_guid: fromDatatype.GuidDataFieldInterface;
  packing_status: fromDatatype.VarcharDatatypeInterface;
}
